import { useMemo } from 'react';

import { CurrencyItem } from './CurrencyItem';
import {
  amountWithCurrencySymbol,
  getCurrencyName,
  mapCurrencyName,
} from '@/helpers/currency';
import { useCommonStore } from '@/store/commonStore';

import { ScDepositSection } from '@/components/Deposit/styled';

export const CurrenciesEnableBlock = () => {
  const pendingWallets = useCommonStore.use.pendingWallets();
  const extendedUserWallets = useCommonStore.use.extendedUserWallets();

  const optionsWallets = useMemo(
    () =>
      extendedUserWallets.map(
        ({ amountCents, currency, subCurrency, icon }) => {
          const name = mapCurrencyName[currency];

          return {
            name: `${amountWithCurrencySymbol(getCurrencyName(subCurrency), amountCents)}${
              name ? ` | ${name}` : ''
            }`,
            value: currency,
            icon,
          };
        }
      ),
    [extendedUserWallets]
  );

  return (
    <ScDepositSection>
      {/* TODO: add translate */}
      <h3 className="title">Active currencies</h3>
      <div className="list">
        {optionsWallets.map(({ value, name, icon }) => (
          <CurrencyItem
            key={value}
            currencyCode={value}
            icon={icon}
            label={name}
            isActive
            disableButton={optionsWallets.length === 1 || pendingWallets}
          />
        ))}
      </div>
    </ScDepositSection>
  );
};
